import React from 'react';
import '../less/main.less';

export default function template() {
    const { img, topImg, text, textMob, title, toggleModal, page, isMobile, btnText, link, subTitle, logo, dates, children, offerMode, complDates, bg } = this.props,
      btn = toggleModal || btnText ?
        (
          <button className="btn-success" id={`banner-button ${page}`} onClick={toggleModal ? toggleModal : () => window.open(link.link, link.target)}>
            {this.l10n(btnText ? btnText : 'SEND_APPLICATION')}
          </button>
        )
        : '',
      topImgBlock = topImg ? (
        <img className="top-image" src={topImg} alt='top_image'/>
      ) : '',
      subTitleBlock = subTitle ? (
        <div className="banner-sub-title" dangerouslySetInnerHTML={{ __html: this.l10n(subTitle) }}/>
      ) : '',
      datesBlock = dates
        ? complDates
          ? dates
          : (<div className="banner-dates" dangerouslySetInnerHTML={{ __html: this.l10n(dates) }} />)
        : "",
      rightSide = img ?
        (<div className="banner-right-side">
          <img className="banner-right-side-img" src={img} alt=" " />
        </div>)
        :
        '';

    return (
      <section className={`banner-module ${page}`}>
        {
          offerMode ?
            <a className="banner-module-content" href={offerMode ? link : null } style={{
              background: `url(${bg}) center / contain no-repeat`}} target={'_blank'}>
              <div className="banner-left-side">
                {topImgBlock}
                {subTitleBlock}
                <div className="banner-title" dangerouslySetInnerHTML={{ __html: this.l10n(title) }}/>
                <div className="banner-message" dangerouslySetInnerHTML={{__html: isMobile ? this.l10n(textMob) : this.l10n(text)}}>
                </div>
                {logo}
                { children ? children : btn}
                {datesBlock}
              </div>
              {rightSide}
            </a>
            :
            <div className="banner-module-content" onClick={offerMode ? toggleModal : null }>
              <div className="banner-left-side">
                {topImgBlock}
                {subTitleBlock}
                <div className="banner-title" dangerouslySetInnerHTML={{ __html: this.l10n(title) }}/>
                <div className="banner-message" dangerouslySetInnerHTML={{__html: isMobile ? this.l10n(textMob) : this.l10n(text)}}>
                </div>
                {logo}
                { children ? children : btn}
                {datesBlock}
              </div>
              {rightSide}
            </div>
        }
      </section>
    );
}
